export default __webpack_public_path__ + "images/bd77bd044b4daf001691fbc28b009933-travel.png";